/**
 * currentEntityId selectors
 */
interface State {
    currentEntityId?: number;
}

const selectCurrentEntityId = (state: State) => state.currentEntityId;

export { selectCurrentEntityId };
